function mockTranslation(str, multiplier) {
  if (typeof multiplier !== 'number') multiplier = +multiplier
  // first replace all word characters with β, keeping dynamic phrases, html tags + &nbsp;
  var mocked = str.replace(
    /({%p, .+,|other{|{%\w, [\w,\s:;]+}|<([^>]+)>|&nbsp;)|[a-zA-Z]/gm,
    function(match, p1) {
      if (p1) return p1
      return 'β'
    }
  )
  // add additional characters (ξ) to each word based on multiplier
  if (typeof multiplier === 'number' && multiplier > 1) {
    var expanded = mocked.replace(/(β+)/gm, function(match, p1) {
      var len = p1.length
      // should expand by a minimum of 1
      var count = Math.floor(len * multiplier - len) || 1
      var addtnl = ''

      while (count--) {
        addtnl += 'ξ'
      }

      return p1 + addtnl
    })
    return expanded
  } else {
    return mocked
  }
}

module.exports = mockTranslation
